module.exports = __webpack_public_path__ + "media/images/gallery/constellations/pegasus/peg_gal-c2ae8716ac00845f14c7b1e9f8190387.gif";